import { mergeDeep } from '@/helpers/utils'
import { ISchema, PaywallComponentProps } from '../@types'

import beforePng from '@/assets/paywall/current-goal/before-alt-images.png'
import afterPng from '@/assets/paywall/current-goal/after-alt-images.png'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			order: [
				'PaywallCountdownQuickAccess',
				'PaywallCurrentGoal',
				'PaywallDiscountAppliedBanner',
				[
					'PaywallTitle',
					({ $t }): PaywallComponentProps.Title => ({
						title: $t('pages.program.title_grab'),
						customStyles: {
							marginTop: '24px',
							paddingTop: '0',
						},
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				'PaywallUserResearchBadge',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_1_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPromocode',
				'PaywallPriceDisclaimer',
				'PaywallRatings',
				'PaywallDietsVsFasting',
				[
					'PaywallButton',
					({ $t, ctx }): PaywallComponentProps.Button => ({
						text: $t('pages.program.buttons.grab_my_plan_to_hit', {
							weight: ctx.localizedUserTargetWeight,
						}),
						type: 'GET_MY_PLAN_HIGHLIGHTS',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallCustomerReviews',
				[
					'PaywallTitle',
					({ $t }): PaywallComponentProps.Title => ({
						title: $t('prepaywall.crm.visible_result.title'),
						customStyles: {
							marginLeft: '20px',
							marginRight: '20px',
						},
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				'PaywallUserResearchBadge',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_2_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPromocode',
				'PaywallPriceDisclaimer',
				'PaywallFooterWithMoneyback',
				'PaywallBillingModal',
				'PaywallDiscountOnAbortModal',
			],
			components: {
				PaywallCountdownQuickAccess: ({ $t, ctx }): PaywallComponentProps.CountdownQuickAccess => {
					return {
						text: $t('female_yoga.pages.paywall.countdown_text', { discount_percent: ctx.discountPercent }),
						buttonEvent: 'scrollToPlanPicker',
						staticShadow: false,
					}
				},
				PaywallDietsVsFasting: ({ $t, ctx, $te }): PaywallComponentProps.DietsVsFasting => {
					const motivationEvent = ctx.answerMotivationEvent[0]
					let title = $t('pages.program.diets_vs_fasting.title')
					if (motivationEvent && $te(`pages.program.diets_vs_fasting.${motivationEvent}`)) {
						title = $t(`pages.program.diets_vs_fasting.${motivationEvent}`)
					}

					return {
						title,
						sex: 'female',
						theme: 'alt-images',
					}
				},
				PaywallCurrentGoal: ({ ctx }): PaywallComponentProps.CurrentGoal => ({
					sex: 'female',
					weight: ctx.localizedUserTargetWeight,
					targetWeight: ctx.localizedUserTargetWeight,
					progressLabel: 'Energy level',
					bodyFatFormat: 'numeric',
					animateArrow: true,
					currentBar: {
						label: 'Now',
						image: beforePng,
					},
					goalBar: {
						label: 'Goal',
						image: afterPng,
					},
				}),
			},
		},
	)
